/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeUser
 */
export interface ChallengeUser {
    /**
     * 
     * @type {string}
     * @memberof ChallengeUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeUser
     */
    nickname: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeUser
     */
    gravatar?: string;
}

export function ChallengeUserFromJSON(json: any): ChallengeUser {
    return ChallengeUserFromJSONTyped(json, false);
}

export function ChallengeUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'nickname': json['nickname'],
        'gravatar': !exists(json, 'gravatar') ? undefined : json['gravatar'],
    };
}

export function ChallengeUserToJSON(value?: ChallengeUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'nickname': value.nickname,
        'gravatar': value.gravatar,
    };
}


